import _extends from "@babel/runtime/helpers/esm/extends";
export function transformLegacyUser(apiGetUserData) {
  var _apiGetUserData$USER, _apiGetUserData$USER2, _apiGetUserData$USER3, _familyConfig$CHILD_C, _familyConfig$MAX_CHI, _familyConfig$CHILD_C2, _familyConfig$MAX_CHI2, _apiGetUserData$USER4;
  const familyConfig = !Array.isArray((_apiGetUserData$USER = apiGetUserData.USER) == null ? void 0 : _apiGetUserData$USER.MULTI_ACCOUNT) ? (_apiGetUserData$USER2 = apiGetUserData.USER) == null ? void 0 : _apiGetUserData$USER2.MULTI_ACCOUNT : undefined;
  const user = {
    id: '0',
    country: apiGetUserData.COUNTRY,
    direction: apiGetUserData.DIRECTION || 'ltr',
    lang: apiGetUserData.SETTING_LANG || 'en',
    locale: apiGetUserData.SETTING_LOCALE || 'en-GB',
    settings: {
      isDarkModeOn: ((_apiGetUserData$USER3 = apiGetUserData.USER) == null || (_apiGetUserData$USER3 = _apiGetUserData$USER3.SETTING) == null || (_apiGetUserData$USER3 = _apiGetUserData$USER3.global) == null ? void 0 : _apiGetUserData$USER3.dark_mode) === 'on'
    },
    familyStatus: familyConfig ? {
      isActive: familyConfig.ACTIVE,
      isEnabled: familyConfig.ENABLED,
      childCount: (_familyConfig$CHILD_C = familyConfig.CHILD_COUNT) != null ? _familyConfig$CHILD_C : 0,
      parent: familyConfig.PARENT ? {
        id: familyConfig.PARENT.id,
        blogName: familyConfig.PARENT.blog_name,
        email: familyConfig.PARENT.email
      } : null,
      isKid: familyConfig.IS_KID,
      remainingAccount: ((_familyConfig$MAX_CHI = familyConfig.MAX_CHILDREN) != null ? _familyConfig$MAX_CHI : 0) - ((_familyConfig$CHILD_C2 = familyConfig.CHILD_COUNT) != null ? _familyConfig$CHILD_C2 : 0),
      isMainAccount: familyConfig.PARENT === null,
      isSubAccount: familyConfig.IS_SUB_ACCOUNT,
      maxChildren: (_familyConfig$MAX_CHI2 = familyConfig.MAX_CHILDREN) != null ? _familyConfig$MAX_CHI2 : 0
    } : {
      isActive: false,
      isEnabled: false,
      childCount: 0,
      parent: null,
      isKid: false,
      isMainAccount: true,
      isSubAccount: false,
      maxChildren: 0,
      remainingAccount: 0
    }
  };
  const id = Number((_apiGetUserData$USER4 = apiGetUserData.USER) == null ? void 0 : _apiGetUserData$USER4.USER_ID);
  if (id !== 0) {
    var _apiGetUserData$USER5, _apiGetUserData$USER6;
    return _extends({}, user, {
      id: id.toString(),
      blogname: (_apiGetUserData$USER5 = apiGetUserData.USER) == null ? void 0 : _apiGetUserData$USER5.BLOG_NAME,
      pictureMD5: (_apiGetUserData$USER6 = apiGetUserData.USER) == null ? void 0 : _apiGetUserData$USER6.USER_PICTURE
    });
  }
  return user;
}
export function transformLegacyChild(child, pictureDomain) {
  return {
    id: child.USER_ID,
    blogname: child.BLOG_NAME,
    isKid: child.IS_KID,
    isMainAccount: child.PARENT_ID === null,
    caption: child.EXTRA_FAMILY.CAPTION,
    permissions: {
      isLoggableAs: child.EXTRA_FAMILY.IS_LOGGABLE_AS,
      isPersonnalDataEditable: child.EXTRA_FAMILY.IS_PERSONAL_DATA_EDITABLE,
      isExplicitLabelEditable: child.EXTRA_FAMILY.IS_EXPLICIT_LEVEL_EDITABLE,
      forceExplicitLevel: child.EXTRA_FAMILY.TOGGLE_EXPLICIT_CONTROL,
      isDeletable: child.EXTRA_FAMILY.IS_DELETABLE,
      isDelinkable: child.EXTRA_FAMILY.IS_DELINKABLE
    },
    getPictureUrl: (width, height, color) => parsePictureMd5toUrl(pictureDomain, child.USER_PICTURE, width, height, color)
  };
}
export function parsePictureMd5toUrl(domain, md5, width = 80, height = 80, color = '000000') {
  const ext = color === 'none' ? 'png' : 'jpg';
  return `https://${domain}/user/${md5}/${height}x${width}-${color}-80-0-0.${ext}`;
}